// @flow
import React, { Component } from 'react';
import facetTypes from '../../utils/search/facetTypes';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './SearchBreadcrumbCategories.module.scss';

type Props = $ReadOnly<{|
    facets: any[],
    isCategoryLanding: boolean,
    taxonomyParentSelected: Function,
|}>;

export default class SearchBreadcrumbCategories extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    renderBreadcrumbsWrapper = () => {
        const breadcrumbs = this.props.facets
            .filter(facet => facet.id === facetTypes.CATEGORY_ID)
            .map(facet => {
                return this.renderBreadcrumbs(facet);
            });

        if (!breadcrumbs || breadcrumbs.length === 0 || breadcrumbs[0] === null) return null;

        return <div className={styles['breadcrumbs-container']}>{breadcrumbs}</div>;
    };

    renderBreadcrumbs = (facet: any) => {
        if (facet.selected) {
            return (
                <span key={facet.id}>
                    {
                        <span className={styles.breadcrumb}>
                            <Link route to="/">
                                <FormattedMessage id="online_auctions" />
                            </Link>
                            <span className={styles.chevron}>›</span>
                        </span>
                    }
                    {facet.parents &&
                        facet.parents.map(parent => {
                            return (
                                <span key={parent.id} className={styles.breadcrumb}>
                                    {this.props.isCategoryLanding && (
                                        <Link route to={`/c/${parent.landingPageUrl}/`} id="category_{parent.id}">
                                            {parent.name}
                                        </Link>
                                    )}
                                    {!this.props.isCategoryLanding && (
                                        <a
                                            onClick={() =>
                                                this.props.taxonomyParentSelected(
                                                    parent.id,
                                                    facet.id,
                                                    facetTypes.CATEGORY_ID
                                                )
                                            }
                                        >
                                            {parent.name}
                                        </a>
                                    )}
                                    <span className={styles.chevron}>›</span>
                                </span>
                            );
                        })}
                    <span className={styles.breadcrumb}>{facet.name}</span>
                </span>
            );
        }

        if (facet.categories && facet.categories.facets && facet.categories.facets.length === 1) {
            return this.renderBreadcrumbs(facet.categories.facets[0]);
        }

        return null;
    };

    render() {
        return this.renderBreadcrumbsWrapper();
    }
}
